import React, { useEffect } from 'react'
import bg from '../../assets/login_bg.png'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { loginRequest } from '../../authConfig/AuthConfig'
import { InteractionStatus } from '@azure/msal-browser'

const Login = () => {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    const hasAuthParams =
      window.location.search.includes('code=') ||
      window.location.search.includes('error=')
    const onRedirectPage =
      window.location.pathname.endsWith('/token') && hasAuthParams
    if (
      !isAuthenticated &&
      inProgress === InteractionStatus.None &&
      !onRedirectPage
    ) {
      const isPostLogout = window.location.pathname.endsWith('/token')
      instance
        .loginRedirect({
          ...loginRequest,
          ...(isPostLogout && {
            redirectStartPage: `${window.location.protocol}//${window.location.host}/`,
          }),
        })
        .catch((e) => {
          console.error('SSO redirect failed:', e)
        })
    }
  }, [isAuthenticated, inProgress, instance])

  return (
    <div className="container-fluid vh-100">
      <div className="row">
        <div className="col-12 vh-100 p-0 position-relative">
          <img width={'100%'} height={'100%'} src={bg} alt="background" />
        </div>
      </div>
    </div>
  )
}
export default Login
